module.exports = __webpack_public_path__ + "img/cpu-icon.2f13758b.svg";